var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 186,
    viewBox: "0 0 203 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7792 -43.9998L222 137L212.013 185.205L-0.000403361 -9.37238L31.7792 -43.9998Z",
    fill: "url(#paint0_linear_1_855)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_855",
    x1: 46.5,
    y1: -37.997,
    x2: 230,
    y2: 145.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E767"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrip);
export default __webpack_public_path__ + "static/media/strip.0d3b81b0978ef47215259abd1e50bbb7.svg";
export { ForwardRef as ReactComponent };